import { Table, Tag } from 'antd'
import React from 'react'
import { AuthData, formatRupiah } from '../../../../../Components/Global';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);


const TableParameter = ({ dataSource }) => {

  const Auth = AuthData();
  const Role = Auth?.Role;

  const columns = [
    // {
    //   key: 'ParameterCode',
    //   title: 'Parameter Code',
    //   dataIndex: 'ParameterCode',
    // },
    {
      key: 'ParameterName',
      title: 'Parameter Name',
      dataIndex: 'ParameterName',
    },
    {
      key: 'ReportNumber',
      title: 'Report Number',
      dataIndex: 'ReportNumber',
    },
    {
      key: 'Methode',
      title: 'Methode',
      dataIndex: 'Methode',
      render: (value) => {
        return value ? value : <p>-</p>;
      }
    },
    {
      key: 'TAT',
      title: 'TAT',
      dataIndex: 'TAT',
    },
    {
      key: 'DueDate',
      title: 'Due Date',
      dataIndex: 'DueDate',
      render: (value) => dayjs.utc(value).format('YYYY-MM-DD')
    },
    {
      key: 'Amount',
      title: 'Amount',
      dataIndex: 'Amount',
      render: (value) => <p>Rp {formatRupiah(value)}</p>
    },
  ];

  if (Role === "Admin") {
    columns.splice(2, 0,
      {
        dataIndex: 'SubcontStatus',
        title: 'Subcont Status',
        key: 'SubcontStatus',
        render: (value) => (
          <Tag color={value ? 'green' : 'red'}> {value ? 'Yes' : 'No'} </Tag>
        ),
      },
      {
        dataIndex: 'Labsubcont',
        title: 'Labsubcont',
        key: 'Labsubcont',
        render: (value) => {
          return value ? value : <p>-</p>;
        }
      },
    );
  }


  return (
    <div>
      <h1 className="border-b-2 pb-1 text-xl mb-2">Parameter</h1>
      <Table
        bordered
        columns={columns}
        dataSource={dataSource}
        scroll={{
          x: 'max-content',
        }}
      />
    </div>
  )
}

export default TableParameter